<template>
  <div class="container">
    <div class="row">
      <div class="col-12">
        <div class="promo_title">
          <Title current-name="Акции">
            Акции
          </Title>
        </div>
      </div>
    </div>
    <div class="row promo_list">
      <nuxt-link
        v-for="(val, i) in items"
        :key="`promo-${ i }`"
        :to="`/promos/${ val.id }`"
        class="promo_list__item  col-12 col-md-6"
        no-prefetch
      >
        <CardPromo
          :img="val.image"
          :title="val.name"
          :imgBgrColor="val.imgBgrColor"
        />
      </nuxt-link>
    </div>
  </div>
</template>

<script>
import Title from '@/components/UI/Title'
import Button from '@/components/UI/Button'
import CardPromo from '@/components/page/CardPromo'

export default {
  /*  head() {
    return {
      title: 'Акции на доставку суши, роллов и пиццы в ресторанах СУШИФОКС',
      meta: [
        {
          hid: 'description',
          name: 'description',
          content: 'Акционные предложения на доставку суши, роллов и пиццы в Санкт-Петербурге от службы доставки СУШИФОКС. Скидки на суши и пиццу!'
        }
      ]
    }
  }, */
  components: { Title, Button, CardPromo },
  async asyncData ({ $axios, store }) {
    try {
      const api = store.getters['api/getPromotions']
      const res = await $axios.get(api)
      const items = res.data.items

      return {
        items,
      }
    } catch (e) {
      return {
        items: [],
      }
    }
  },
}
</script>

<style lang="less">
.promo {
	&_title {
		margin-bottom: 20px;
		margin-top: 20px;
	}

	&_list {
		margin-bottom: 27px;
	}
}
.promo_list__item{
	color: #000;
	text-decoration: none;
}
</style>
